import { render, staticRenderFns } from "./RescreenDialog.vue?vue&type=template&id=d8b8aa9e&scoped=true"
import script from "./RescreenDialog.vue?vue&type=script&lang=js"
export * from "./RescreenDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b8aa9e",
  null
  
)

export default component.exports